import React from 'react';
import { Container, Typography } from '@mui/material';

const Profile = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h4">Mi Perfil</Typography>
      <Typography variant="body1" sx={{ mt: 2 }}>
        Página de perfil en construcción...
      </Typography>
    </Container>
  );
};

export default Profile; 